<template>
    <v-container class="ufv-container-pages d-flex flex-column pt-0">
        <div class="ufv-container-text">
            <div class="text-h4">{{ $t("Atendimento") }}</div>
            <div class="">{{ $t("EscolhaUmaOpcaoParaIniciar") }}</div>
        </div>
        <div class="d-flex justify-space-between align-center my-3">
            <v-text-field
                style="border: 0px solid green"
                append-icon="mdi-magnify"
                dense
                hide-details
                placeholder="Procurar Serviço"
                class="ml-0 flex-grow-1"
                filled
                v-model="filtro"
                :loading="!filtroDisponivel"
                :disabled="!filtroDisponivel"
            >
            </v-text-field>
        </div>
        <div v-if="!loading" class="my-3">
            <v-row dense>
                <v-col
                    v-for="(arvore, i) in arvoresFiltradas"
                    :key="i"
                    :cols="colunas"
                >
                    <Item :arvore="arvore" class="fill-height" />
                </v-col>
            </v-row>
        </div>
        <div v-else class="ufv-menu-loading d-flex justify-center">
            <spinner />
        </div>
    </v-container>
</template>

<script>
import Fuse from "fuse.js";
import debounce from "lodash/debounce";
import Item from "./AtendimentoCard.vue";
import Utils from "../../utils/Utils";
import Spinner from "../../componentes/ui/Spinner.vue";
import RequestCancelled from "../../api/RequestCancelled";
import { flattenValuesToString } from "../../utils/general";
import { mapGetters } from "vuex";

export default {
    name: "painel-servicos",
    components: {
        Item,
        Spinner,
    },
    data: () => ({
        arvores: [],
        arvoresFiltradas: [],
        loading: true,
        filtroDisponivel: false,
        filtro: "",
        fuse: null,
    }),
    methods: {
        buscarArvores() {
            this.loading = true;
            this.$servicoAtendimento
                .getArvores("", this.contexto.id)
                .then((arvores) => {
                    this.arvores = arvores || [];
                    this.arvoresFiltradas = this.arvores;
                    this.loading = false;
                    return this.arvores;
                })
                .then((arvores) => {
                    return Promise.all(
                        arvores.map((arvore) =>
                            this.$servicoAtendimento
                                .getArvorePorId(arvore.id, this.contexto.id)
                                .then((arvoreCompleta) => ({
                                    id: arvoreCompleta.id,
                                    nome: arvoreCompleta.nome,
                                    descricao: arvoreCompleta.descricao,
                                    tags: arvoreCompleta.tags,
                                    texto: flattenValuesToString(arvoreCompleta),
                                }))
                                .catch(() => null),
                        ),
                    );
                })
                .then((arvoresCompletas) => {
                    this.arvores = arvoresCompletas.filter(
                        (arvore) => arvore !== null,
                    );
                    this.fuse = new Fuse(this.arvores, {
                        keys: [
                            { name: "tags", weight: 3 },
                            { name: "descricao", weight: 2 },
                            { name: "nome", weight: 2 },
                            { name: "texto", weight: 1 },
                        ],
                        threshold: 0.7,
                        includeMatches: true,
                        findAllMatches: true,
                        ignoreLocation: true,
                    });
                    this.filtrarArvores();
                    this.filtroDisponivel = true;
                })
                .catch((error) => {
                    if (error instanceof RequestCancelled) {
                        return;
                    }
                    console.log(error);
                    this.$router.push(Utils.errorToRoute(error));
                });
        },
        filtrarArvores() {
            if (!this.filtro) {
                this.arvoresFiltradas = this.arvores;
            } else if (!this.fuse) {
                this.arvoresFiltradas = this.arvores;
            } else {
                const result = this.fuse.search(this.filtro.toLowerCase());
                this.arvoresFiltradas = result.map((r) => r.item);
            }
            this.loading = false;
        },
    },
    created() {
        this.filtro = this.$route.query.filtro || "";
        this.buscarArvores();
    },
    computed: {
        colunas() {
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                case "sm":
                case "md":
                    return 12;
                default:
                    return 6;
            }
        },
        ...mapGetters("contexto", ["contexto"]),
    },
    watch: {
        filtro: debounce(function () {
            this.filtrarArvores();
        }, 500),
        contexto(novo, antigo) {
            if (novo === antigo) {
                return;
            }

            this.buscarArvores();
        },
    },
};
</script>

<style scoped>
.ufv-menu-loading {
    margin-top: 5%;
}
</style>
